import Backbone from 'backbone';

import { appUrl } from 'utils/wrappers';
import { showError } from 'utils/messages';

import Base from 'app/views/base';
import LoaderView from 'app/views/loader';
import tmpl from 'templates/usps_zone_lookup';

export const USPSZone = Backbone.Model.extend({
  url: appUrl('usps_zones'),
});

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #lookup-form': 'submit',
  },

  initialize() {
    this.model = new USPSZone({});
    this.listenTo(this.model, 'change error', this.render);
    this.addSubview('zoneLoader', '#zone_loader', new LoaderView({ type: 'flat', model: this.model }));
  },

  context() {
    return {
      zone: this.model.get('usps_zone'),
      fromZip: this.model.get('fromZip'),
      toZip: this.model.get('toZip'),
    };
  },

  submit(e) {
    e.preventDefault();
    const form = $(e.target);
    this.model.unset('usps_zone');
    this.model.set('fromZip', form.find('#from-zip').val());
    this.model.set('toZip', form.find('#to-zip').val());
    this.model.fetch({
      data: {
        from: this.model.get('fromZip'),
        to: this.model.get('toZip'),
      },
      success(model) {
        if (!model.get('usps_zone')) showError('No Results');
      },
      error() {
        showError('Invalid Zones');
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/usps_zone_lookup_page.js